import { render, staticRenderFns } from "./6.vue?vue&type=template&id=677dc8bd&scoped=true&"
import script from "./6.vue?vue&type=script&lang=js&"
export * from "./6.vue?vue&type=script&lang=js&"
import style0 from "./6.vue?vue&type=style&index=0&id=677dc8bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677dc8bd",
  null
  
)

export default component.exports